module.exports = __webpack_public_path__ + "static/img/htjj.4bf079d9.png";